import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/MyContext";
import { Link, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Book,
  Rocket,
  ArrowRight,
  AlertCircle,
  ChevronDown,
  ChevronUp,
  Check,
  Zap,
  Shield,
  Badge,
  Plus,
} from "lucide-react";
import { memberships } from "@/data/memberships";
import CourseContent from "@/components/CourseContent";
import { productDescriptions } from "@/components/ProductDetails";
import { useToast } from "@/components/ui/use-toast";
import { CourseModule } from "@/data/courseContent";

const Dashboard = () => {
  const { user, getAllUsers, getModule } = useAuth();
  // let userMemberships= [{id:'0', name: 'some'}]

  const { toast } = useToast();
  const [modules, setModules] = useState<CourseModule[]>([]);
  const [expandedProducts, setExpandedProducts] = useState<
    Record<string, boolean>
  >({});
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      setRefreshKey((prev) => prev + 1);
    }, 2000);
    getAllUsers();
   ( async () => {
      const module = await getModule();
      setModules(module);
    })()
    return () => clearInterval(refreshInterval);
  }, []);

  if (!user) {
    return <Navigate to="/login" />;
  }

  const getCurrentUserMemberships = () => {
    const allUsers = JSON.parse(localStorage.getItem("allUsers") || "[]");
    const currentUser = allUsers.find((u: any) => u.email === user.email);
    return currentUser?.memberships || [];
  };

  const handleContactSupport = () => {
    window.location.href = "mailto:support@applaunchai.com";
  };

  const findUserMemberships = () => {
    const currentMemberships = getCurrentUserMemberships();
    if (!currentMemberships.length) return [];

    return currentMemberships
      .map((id) => {
        const membership = memberships.find((m) => m.id === id);
        return membership ? membership : null;
      })
      .filter(Boolean);
  };

  const findAvailableUpgrades = () => {
    const userMembershipIds = getCurrentUserMemberships();
    return memberships.filter(
      (m) => !userMembershipIds.includes(m.id) && m.id !== "ai-prompts"
    );
  };

  const toggleProductExpand = (productId: string) => {
    setExpandedProducts((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  const handleGetUnlimited = () => {
    window.location.href =
      "https://connect.intuit.com/pay/Venture24/scs-v1-810fb25f51ee4adaa74f3c37c01811e3ed02c9b24e2a4fa3aa6672960c45341ae3e25515e44448fbb25170fc5c0562e6?locale=EN_US";
  };

  const handleGetEliteVIP = () => {
    window.location.href =
      "https://connect.intuit.com/pay/Venture24/scs-v1-546ab3219a574050bda67734df9112080fe4e363fb924f8b91cee95101d9f7d2920b9289cd584be5ab9708a3c900910a?locale=EN_US";
  };

  const handlePricingLinkClick = () => {
    window.scrollTo(0, 0);
  };

  const userMemberships = findUserMemberships();
  const availableUpgrades = findAvailableUpgrades();

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mb-8">
        {/* <h1 className="text-3xl font-bold">Welcome back, {user.name}</h1> */}
        <p className="text-gray-600 mt-2">
          Access all your purchased content below
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        <div className="md:col-span-2">
          <CourseContent key={refreshKey} />
        </div>

        <div className="space-y-6 ">
          {userMemberships.length > 0 ? (
            <Card>
              <CardHeader>
                <CardTitle>Your Memberships</CardTitle>
              </CardHeader>
              <CardContent>
                {userMemberships.length > 0 ? (
                  <ul className="space-y-2">
                    {userMemberships.map((membership) => (
                      <li
                        key={membership!.id}
                        className="flex items-center gap-2"
                      >
                        <Rocket className="h-4 w-4 text-blue-500" />
                        <span>{membership!.name}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="text-center p-4">
                    <AlertCircle className="mx-auto h-8 w-8 text-amber-500 mb-2" />
                    <p className="text-sm text-gray-600">
                      You don't have any active memberships.
                    </p>
                  </div>
                )}
              </CardContent>
              <CardFooter>
                <Link
                  to="/pricing"
                  onClick={handlePricingLinkClick}
                  className="w-full"
                >
                  <Button variant="outline" className="w-full">
                    View All Memberships
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          ) : null}

          {availableUpgrades.length > 0 && (
            <Card className="border-blue-100 bg-blue-50">
              <CardHeader className="pb-2">
                <CardTitle className="text-blue-800">
                  Recommended Upgrades
                </CardTitle>
                <CardDescription>
                  Take your app development to the next level
                </CardDescription>
              </CardHeader>
              <CardContent>
                {/* <div className="space-y-4">
                  {availableUpgrades.slice(0, 5).map(upgrade => (
                    <div key={upgrade.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                      <div className="p-4">
                        <div className="flex justify-between items-start">
                          <h4 className="font-medium">
                            {upgrade.id === 'ai-prompts' ? 'AI Development Swipe File & Prompts' : upgrade.name}
                          </h4>
                          <span className="text-sm font-bold">${upgrade.price}</span>
                        </div>
                        <p className="text-xs text-gray-600 mt-1 mb-3">{upgrade.description}</p>
                        
                        {expandedProducts[upgrade.id] && upgrade.id in productDescriptions && (
                          <div className="mt-3 pt-3 border-t">
                            {productDescriptions[upgrade.id as keyof typeof productDescriptions]}
                          </div>
                        )}
                        
                        <div className="flex justify-between items-center mt-3">
                          {upgrade.id in productDescriptions && (
                            <button 
                              onClick={() => toggleProductExpand(upgrade.id)}
                              className="text-xs text-blue-600 flex items-center gap-1 hover:underline"
                            >
                              {expandedProducts[upgrade.id] ? (
                                <>
                                  <ChevronUp size={14} />
                                  Show less
                                </>
                              ) : (
                                <>
                                  <ChevronDown size={14} />
                                  View details
                                </>
                              )}
                            </button>
                          )}
                          
                          <Link to={`/purchase/${upgrade.id}`}>
                            <Button size="sm" className="text-xs bg-orange-500 hover:bg-orange-600 text-white">
                              Upgrade <ArrowRight className="h-3 w-3 ml-1" />
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}

                {/* Beginning */}
                {modules.map((module) => (
                  <div
                    key={module.id}
                    className="border rounded-md overflow-hidden mb-4"
                  >
                    <div className="p-4 bg-slate-50 flex items-center justify-between">
                      <div>
                        <div className="flex items-center gap-2">
                          <h3 className="text-lg font-semibold">
                            {module.title}
                          </h3>
                          {/* <Badge variant="outline">
                            {accessLevels.find(
                              (a) => a.id === module.accessLevel
                            )?.name || module.accessLevel}
                          </Badge> */}
                        </div>
                        <p className="text-sm text-gray-600 mt-1">
                          {module.description}
                        </p>
                      </div>
                      {/* <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleAddItem(module.module_id)}
                        >
                          <Plus className="mr-1 h-4 w-4" /> Add Content
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleEditModule(module)}
                        >
                          <Edit className="mr-1 h-4 w-4" /> Edit
                        </Button>
                        <Button
                          variant="destructive"
                          size="sm"
                          onClick={() => handleDeleteModule(module.id)}
                        >
                          <Trash2 className="mr-1 h-4 w-4" /> Delete
                        </Button>
                      </div> */}
                    </div>
                    <div className="divide-y">
                      {module.items && module.items?.length === 0 ? (
                        <div className="p-6 text-center text-gray-500">
                          No content items in this module.
                          {/* <div className="mt-2">
                            <Button
                              variant="outline"
                              size="sm"
                            >
                              <Plus className="mr-1 h-4 w-4" /> Add Content Item
                            </Button>
                          </div> */}
                        </div>
                      ) : (
                        module.items &&
                        module.items.map((item) => (
                          <div
                            key={item.id}
                            className="p-4 flex items-center justify-between hover:bg-gray-50"
                          >
                            <div className="flex items-center gap-3">
                              <div>
                                <h4 className="font-medium">{item.title}</h4>
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                 
                                  {item.duration && (
                                    <span>{item.duration}</span>
                                  )}
                                  <span className="text-xs text-gray-400">
                                    ({item.accessLevel})
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                ))}
                {/* Ending */}
              </CardContent>
            </Card>
          )}

          <Card>
            <CardHeader>
              <CardTitle>Need Help?</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600">
                Our support team is ready to assist you with any questions about
                your membership.
              </p>
            </CardContent>
            <CardFooter>
              <Button
                variant="outline"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white"
                onClick={handleContactSupport}
              >
                Contact Support
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-6">
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-lg overflow-hidden border border-blue-100">
          <div className="p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-full bg-blue-100">
                <Zap className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-left">
                Unlimited AI App Development for One Monthly Price
              </h3>
            </div>
            <p className="text-gray-700 mb-6 text-left">
              No contract, cancel anytime.
            </p>
            <p className="text-sm text-gray-500 mb-4 text-left">
              Get unlimited AI app builds, updates, and expert support—no extra
              fees, no limits.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-left">
                  Continuous improvements and optimization of your apps
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-left">
                  Priority support from our development team
                </span>
              </li>
            </ul>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">
                $599
                <span className="text-sm font-normal text-gray-600">
                  /month
                </span>
              </div>
              <Button
                className="bg-orange-500 hover:bg-orange-600 text-white"
                onClick={handleGetUnlimited}
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl shadow-lg overflow-hidden border border-purple-100">
          <div className="p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-full bg-purple-100">
                <Shield className="h-6 w-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-left">
                We Build & Launch Your AI App for You—From Idea to Market
              </h3>
            </div>
            <p className="text-gray-700 mb-6 text-left">
              A done-for-you AI app development service with custom branding,
              monetization, and launch strategy built in.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-left">
                  A done-for-you AI app development service with custom
                  branding, monetization, and launch strategy built in.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-left">
                  Professional design and development from industry experts
                </span>
              </li>
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-green-500 flex-shrink-0" />
                <span className="text-left">
                  Dedicated account manager and VIP support
                </span>
              </li>
            </ul>
            <div className="flex items-center justify-between">
              <div className="text-2xl font-bold">
                $4,999
                <span className="text-sm font-normal text-gray-600">
                  /one-time
                </span>
              </div>
              <Button
                className="bg-orange-500 hover:bg-orange-600 text-white"
                onClick={handleGetEliteVIP}
              >
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
